let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("g2304")).then(() => parcelRequire('6uQPF'));